import React, { useEffect, useRef, useState } from 'react';

export function useSectionFeedback() {
    const [feedback, setFeedback] = useState(null);
    const timerRef = useRef(null);

    useEffect(() => () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    function showFeedback(type, message) {
        if (timerRef.current) clearTimeout(timerRef.current);
        setFeedback({ type, message });
        if (type === 'success') {
            timerRef.current = setTimeout(() => setFeedback(null), 3000);
        }
    }

    return { feedback, showFeedback };
}

export function Feedback({ feedback }) {
    return (
        <span
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className={feedback ? `sfm-feedback sfm-feedback-${feedback.type}` : undefined}
        >
            {feedback?.message}
        </span>
    );
}
